module.exports = __webpack_public_path__ + "static/media/reprinticon.a1839aa1.svg";